<template>
  <div class="image-gallery">
      <div class="image-tile" v-for="(img, i) in imageTiles" :key="i" @click="selectedIndex = i">
        <div v-if="img.caption" class="caption">{{img.caption}}</div>
        <div><img class="img-frame" :src="img.src" :alt="img.alt" :title="img.title || img.caption"/></div>
        <div v-if="img.description" class="description">{{img.description}}</div>
      </div>
      
      <transition name="fade">
        <div class="overlay" v-if="selectedIndex != null" @click="selectedIndex = null">
          <div v-if="selectedIndex > 0" class="control rounded chevron chevron-left" @click.stop="selectedIndex--">&lt;</div>
          <transition-group class="img-container" name="fade">
            <img class="img-frame" :key="selectedImage.src" :src="selectedImage.src" :alt="selectedImage.alt" :title="selectedImage.title || selectedImage.caption"/>
          </transition-group>
          <div v-if="selectedIndex < images.length - 1" class="control rounded chevron chevron-right" @click.stop="selectedIndex++">&gt;</div>
        </div>
      </transition>
  </div>
</template>

<script>
export default {
  name: "Home",
  props: {
      images:{type:Array, required: true}
  },
  data(){
    return {
      selectedIndex: null
    }
  },
  computed:{
    imageTiles(){
      return this.images.map(v=>{ return typeof(v) === "string" ? {src:v} : v})
    },
    selectedImage(){
      return this.images[this.selectedIndex];
    }
  },
  methods:{
      resolveUrl(imageUrl) {
        return require(imageUrl);
    }
  }
};
</script>

<style>
.image-gallery{
  --max-image-width: 360px;
  --max-image-height: 270px;

  display: grid;
  align-items: center;
  justify-items: center;
  grid-gap: 16px;
  grid-template-columns: repeat(auto-fill, minmax(var(--max-image-width), 1fr));
}

.image-gallery > .image-tile{
  display: grid;
  grid-template-rows: min-content 1fr min-content;
  transition: transform .2s;
  cursor: pointer;
}

.image-gallery > .image-tile:hover{
  transform: scale(1.05)
}

.image-gallery > .image-tile > img{
  grid-row: 1/3;
}

.image-gallery > .image-tile > .caption{
  grid-row: 1;
}

.image-gallery > .image-tile > .description{
  grid-row: 3;
}

.image-gallery > .overlay{
  display: grid;
  grid-template-columns: min-content 1fr min-content;
  align-items: center;
  justify-items: center;
  padding: 8px 16px;
  position: absolute;
  left:0;
  right:0;
  top: 0;
  bottom: 0;
  background: rgba(255,255,255,.5);
  z-index: 2
}


.image-gallery > .overlay .img-container{
  display: grid;
  align-self: stretch;
  justify-self: stretch;

  align-items: center;
  justify-items: center;

  grid-template-columns: 1fr;
  grid-template-rows: 1fr;

  grid-column: 2;
  grid-row: 1;
}

.below-lg .image-gallery > .overlay .img-container{
  grid-column: 1/span 3;
  grid-row: 1;
}

.image-gallery > .overlay .img-frame{
  max-width:100%;
  max-height:100%;
}

.image-gallery > .overlay .chevron{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  z-index: 3;
  margin: 16px;
}

.image-gallery > .overlay .chevron-left{
  grid-column: 1;
  grid-row: 1;
}

.image-gallery > .overlay .chevron-right{
  grid-column: 3;
  grid-row: 1;
}

.fade-enter-active {
  will-change: opacity;
  animation: fade .5s;
  z-index: 1;
}

:not(.img-frame).fade-leave-active {
  will-change: opacity;
  animation: fade .5s reverse;
  z-index: 0;
}

@keyframes fade {
  0% {
    opacity: var(--fade-from, 0);
  }
  100% {
    opacity: var(--fade-to, 1);
  }
}
</style>
